<template>
    <div id="bar-control-overlay"
         v-bind:class="bar_control_overlay"
         v-if="!isFetching">
        <video-line-bar
            @timeEvent="handleTimeEvent"
            v-if="!isFetching"></video-line-bar>
        <controls-view
            ref="controlsView"
            @timeEvent="handleTimeEvent"
            :currentTimePlayer="currentTimePlayer"
            v-if="!isFetching"></controls-view>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ControlsView from "@/playerVue3/components/controlbar/controls-view.vue";
import VideoLineBar from "@/playerVue3/components/controlbar/video-line-bar.vue";

// INITIALIZE STORE & COMPOSABLES

// PROPS & EMITS
const props = defineProps({
    currentTimePlayer: {
        type: Number,
        default: 0,
    },
});

// REACTIVE VARIABLES
const bar_control_overlay = ref('bar-control-overlay-horizontal');
const currentTimeVideoSeconds = ref(0);
const isFetching = ref(false);
const controlsView = ref(null);

// COMPUTED PROPERTIES

// METHODS
const closeBar = () => {
    // TODO, si el video esta en pausa, no se cierra el control bar
    setTimeout(() => {
        $('#bar-control-overlay').css({opacity: 0, bottom: -50, padding: 0, transition: '0.3s'});
    }, 3000);
};

const handleTimeEvent = (currentTime) => {
    currentTimeVideoSeconds.value = currentTime;
};

const showBar = () => {
    $('#bar-control-overlay').css({opacity: 1, bottom: -1, transition: '0.3s'});
};

// LIFECYCLE HOOKS
onMounted(() => {
    const videoContainer = $('#container-video-body');

    videoContainer.on('mouseenter, mousemove', () => {
        showBar();
    });

    videoContainer.on('mouseleave', () => {
        if (jwplayer(document.getElementById('videoTag')).getState() === 'playing') {
            closeBar();
        }
    });

    videoContainer.on('touchend', () => {
        if (jwplayer(document.getElementById('videoTag')).getState() === 'playing') {
            closeBar();
        } else if (jwplayer(document.getElementById('videoTag')).getState() === 'paused') {
            showBar();
        }
    });
});
</script>
